import { useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { getIsMd } from '../../../redux/selectors';
import { TextArea } from '../..';

const TextAreaRow = ({
	label,
	children,
	rows = 5,
	tooltip,
	required = false,
	...rest
}) => {
	const theme = useTheme();
	const useStyles = makeStyles(() => () => {
		const rootHeight = 5 * 20 + 50;
		return {
			textFieldRowRoot: {
				width: '100%',
				height: '150px',
				position: 'relative',
				maxWidth: theme.width.contentMax,
				minWidth: theme.width.contentMin,
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				[theme.breakpoints.down('md')]: {
					minWidth: 'unset',
				},
			},
			textFieldRowLabelContainer: {
				color: theme.palette.font.gray,
				padding: '22px 0',
				fontSize: '16px',
				width: '150px',
				height: '100%',
				minWidth: '150px',
				display: 'flex',
				justifyContent: 'flex-start',
				flexDirection: 'row',
				[theme.breakpoints.down('md')]: {
					display: 'none',
				},
			},

			textFieldRowInput: {
				width: 'calc(100% - 150px)',
				[theme.breakpoints.down('md')]: {
					width: '100%',
				},
			},
		};
	});
	const classes = useStyles();
	const isMd = useSelector(getIsMd);

	return (
		<div className={classes.textFieldRowRoot}>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					color: 'gray',
				}}>
				{label}
				<p style={{ color: 'red' }}>*</p>
			</div>
			<div className={classes.textFieldRowInput}>
				<TextArea
					required
					minRows={5}
					{...rest}
					label={isMd && label ? label : null}></TextArea>
			</div>
		</div>
	);
};

export default TextAreaRow;
